export const ADDITIONAL_SUPERVISOR_FORM_QUERY = `AdditionalSupervisorForms {  
    additionalSupervisorForms(sort: "id:ASC"){
        data{
            id
            attributes{
                program_title
                application_name
                form_fields
            }
        }
    }
}`;
